module.exports = __webpack_public_path__ + "static/media/2018-11-10 surf-up.35d42f29.md";